import Vue              from "vue"
import VueRouter        from "vue-router"
// import NProgress from "nprogress"
// import "nprogress/nprogress.css"
//import views
import Messages             from "@/views/messages-view.vue"
import OrderCreateView      from "@/views/order-create-view.vue"
import Title02View          from "@/views/title02-view.vue"
import Title03View          from "@/views/title03-view.vue"
import Title04View          from "@/views/title04-view.vue"
import Title05View          from "@/views/title05-view.vue"
import Title06View          from "@/views/title06-view.vue"
import Title07View          from "@/views/title07-view.vue"
import Title08View          from "@/views/title08-view.vue"
import Title09View          from "@/views/title09-view.vue"
import SoftwareLicenseView  from "@/views/software-license-view.vue"

import Test         from "@/views/test.vue"

Vue.use(VueRouter);
const routes = [
    {
        path        : '/',
        redirect    : '/messages',
        name        : 'home',
    },{
        path        : '/messages',
        component   : Messages,
        name        : 'messages',
    },{
        path        : '/order-create',
        component   : OrderCreateView,
        name        : 'order-create',
    },{
        path        : '/title02',
        component   : Title02View,
        name        : 'title02',
    },{
        path        : '/title03',
        component   : Title03View,
        name        : 'title03',
    },{
        path        : '/title04',
        component   : Title04View,
        name        : 'title04',
    },{
        path        : '/title05',
        component   : Title05View,
        name        : 'title05',
    },{
        path        : '/title06',
        component   : Title06View,
        name        : 'title06',
    },{
        path        : '/title07',
        component   : Title07View,
        name        : 'title07',
    },{
        path        : '/title08',
        component   : Title08View,
        name        : 'title08',
    },{
        path        : '/title09',
        component   : Title09View,
        name        : 'title09',
    },{
        path        : '/software-license',
        component   : SoftwareLicenseView,
        name        : 'software-license',
    },{
        path        : '/test',
        component   : Test,
        name        : 'test',
    }
];

const router = new VueRouter({
    mode    : "abstract",
    routes  : routes
});

router.replace('/') //load default page

// router.beforeEach((next) => {
//     NProgress.start();
//     next();
// })
//
// router.afterEach((next) => {
//     NProgress.done();
//     next();
// })
//




export default router;
